<a mat-button href="{{ loginUrl }}">Login to Continue</a>
